import React from 'react';
import Chip from '../shared/Chip';
import { initialsOf, initialsStyle } from '../Account/avatar';
import { askedCountLabel, askersFrom } from './sharedQueries';

const MAX_AVATARS = 3;

/**
 * Header over a shared conversation (PRD-1571 R7, Frame 2): the query name, a
 * "Shared with organization" chip, the owner, and the people who have asked
 * at least one turn — not everyone who can see it.
 */
function SharedConversationHeader({ thread, ownerName, turns }) {
  const askers = askersFrom(turns);
  const shown = askers.slice(0, MAX_AVATARS);
  const more = askers.length - shown.length;
  return (
    <div className="shared-conversation-header">
      <span className="shared-conversation-title">{thread.title || 'Untitled conversation'}</span>
      <Chip className="shared-conversation-chip">Shared with organization</Chip>
      <span className="shared-conversation-owner">Owner: {ownerName}</span>
      {askers.length > 0 && (
        <span className="shared-conversation-askers">
          <span className="shared-conversation-stack" aria-hidden="true">
            {shown.map((a) => (
              <span key={a.id} className="message-avatar message-avatar--initials" style={initialsStyle(a.name, '')} title={a.name}>
                {initialsOf(a.name)}
              </span>
            ))}
            {more > 0 && <span className="message-avatar message-avatar--initials shared-conversation-more">+{more}</span>}
          </span>
          {askedCountLabel(askers.length)}
        </span>
      )}
    </div>
  );
}

export default SharedConversationHeader;
